import React from "react";
import "../styles/Footer.css";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-contact">
                <img src="/logo.png" alt="Medamos Logo" className="footer-logo" />

                <div className="contact-item">
                    <strong>Address:</strong><br />
                    Medamos Life Sciences (P) Ltd<br />
                    No. C-11, KSSIDC ESTATE, Kumbalgodu, <br />
                    Bidadi, Bangalore Rural - 560074
                </div>

                <div className="contact-item">
                    <strong>Call Us:</strong><br />
                    +91-9663148668
                </div>

                <div className="contact-item">
                    <strong>Email:</strong><br />
                    medamoslifescience@gmail.com
                </div>
            </div>

            <div className="footer-separator"></div>

            <div className="footer-bottom">
                Copyright © 2025 - Medamos. All rights reserved | Designed By Web Development Company in Bangalore - Vistas
            </div>
        </footer>
    );
}
